import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.title',
    defaultMessage: 'Bulk add tasks',
  },
  versions: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.versions',
    defaultMessage: 'Versions',
  },
  versionsDescription: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.versionsDescription',
    defaultMessage: 'The tasks below are added to every version you select',
  },
  taskTypesDescription: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.taskTypesDescription',
    defaultMessage: 'Pick a type more than once to add it multiple times per version',
  },
  purchaseOrder: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.purchaseOrder',
    defaultMessage: 'P.O. for the new tasks',
  },
  purchaseOrderDescription: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.purchaseOrderDescription',
    defaultMessage: 'Leave empty to add the tasks without a P.O.',
  },
  selectAll: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.selectAll',
    defaultMessage: 'Select all versions',
  },
  deselectAll: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.deselectAll',
    defaultMessage: 'Deselect all versions',
  },
  noVersions: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.noVersions',
    defaultMessage: 'This order has no versions to add tasks to yet.',
  },
  summary: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.summary',
    defaultMessage: '{tasks} {tasks, plural, one {task} other {tasks}} on {versions} {versions, plural, one {version} other {versions}}',
  },
  add: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.add',
    defaultMessage: 'Add tasks',
  },
  adding: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.adding',
    defaultMessage: 'Adding..',
  },
  created: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.components.BulkAddTasksModal.created',
    defaultMessage: '{count} {count, plural, one {task} other {tasks}} added',
  },
})
